/** custom-blue 文案 */
export default {
  paymentAccountPopup: {
    warning: {
      en: 'Ensure the wallet number is entered correctly. Incorrect information may result in the loss',
      sw: 'Hakikisha nambari ya pochi imewekwa kwa usahihi. Taarifa isiyo sahihi inaweza kusababisha hasara',
    },
    submit: {
      en: 'I have confirmed, the next step is',
      sw: 'Nimethibitisha, hatua inayofuata ni',
    },
    inputPlaceholder: {
      en: 'Electronic wallet account',
      sw: 'Akaunti ya pochi ya kielektroniki',
    },
  },
  checkoutPage: {
    tagline: {
      en: 'SECURE · GLOBAL · INNOVATIVE',
      sw: 'SALAMA · KIMATAIFA · UBUNIFU',
    },
    title: {
      en: 'Recharge cashier',
      sw: 'Kasha la malipo',
    },
    subtitle: {
      en: 'Accurate coverage and global growth, one-stop digital promotion solution.',
      sw: 'Suluhisho la kidijitali la malipo lenye usahihi na ukuaji wa kimataifa.',
    },
    amountLabel: {
      en: 'Amount Payable',
      sw: 'Kiasi cha Kulipwa',
    },
    countdownLabel: {
      en: 'Countdown',
      sw: 'Muda uliosalia',
    },
    payeePrefix: {
      en: 'Payee',
      sw: 'Mpokeaji',
    },
    accountHolderLabel: {
      en: 'Account Holder Generated by Bank System',
      sw: 'Mmiliki wa akaunti aliyetolewa na mfumo wa benki',
    },
    sheetIntro: {
      en: 'Please enter your payment electronic wallet number. Supported networks: Vodafone, MTN, AirtelTigo',
      sw: 'Tafadhali weka nambari yako ya pochi ya kielektroniki ya malipo. Mitandao inayotumika: Vodafone, MTN, AirtelTigo',
    },
    walletLabel: {
      en: 'Electronic wallet account',
      sw: 'Akaunti ya pochi ya kielektroniki',
    },
    copyLabel: {
      en: 'COPY',
      sw: 'NAKILI',
    },
    accountSectionLabel: {
      en: 'Please use your account to make the payment.',
      sw: 'Tafadhali tumia akaunti yako kufanya malipo.',
    },
  },
  successPage: {
    title: {
      en: 'Recharge successful',
      sw: 'Malipo yamefanikiwa',
    },
    subtitle: {
      en: 'Your payment has been successfully processed and the funds will be credited soon.',
      sw: 'Malipo yako yameshughulikiwa kwa mafanikio na fedha zitawekwa hivi karibuni.',
    },
    statusLabel: {
      en: 'Status verification',
      sw: 'Uthibitishaji wa hali',
    },
    statusValue: {
      en: 'Successed',
      sw: 'Imefanikiwa',
    },
  },
};
